import React, { useEffect, useRef, useState } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import emailjs from '@emailjs/browser';

const Popupform = () => {
  const form = useRef();
  const [isFormSent, setIsFormSent] = useState(null);

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      // const result = await emailjs.sendForm('service_58qu0nj', 'template_ly2e5pj', form.current, 'f4ltoOg97D8IiIXGL');
      // console.log(result.text);
      const result = await emailjs.sendForm('service_8oz93pa', 'template_538ifl8', form.current, 'pwrhEhHQSLybQbGr9');
      console.log(result , "result");

      console.log('message sent from user:' );
      console.log('message sent');
      setIsFormSent(true);
    } catch (error) {
      console.error(error.text);
      console.error('message not sent');
      setIsFormSent(false);
    }
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      {/* contact form */}
      <div className='avt-contact-form-wrap avt-contact-form-light-ver-wrap'>
        
        <form ref={form} onSubmit={sendEmail}>
          <div className="avt-input-wrap">
            <input type="text" name="user_name" placeholder="What’s your name?" required />
          </div>
          <div className="avt-input-wrap">
            <input type="email" name="user_email" placeholder="How about your email address?" required />
          </div>
          <div className="avt-input-wrap">
            <input type="text" name="your_phone" placeholder="What’s your phone number?" required />
          </div>
          <div className="avt-input-wrap">
            <textarea name="message" placeholder="Please provide us a small summary of your project." cols={30} rows={2} required />
          </div>
          <div className="avt-submit-wrap">
            <button className="avt-btn" type="submit">
              <span>Send</span>
            </button>
          </div>
        </form>
        {isFormSent === true && <div className="avt-form-sent">Form sent successfully!</div>}
        {isFormSent === false && <div className="avt-form-failed">Form submission failed. Please try again.</div>}
      </div>
      {/* contact form */}
    </div>
  );
};

export default Popupform;
